import { render } from "./TopPartners.vue?vue&type=template&id=e9d976a8"
import script from "./TopPartners.vue?vue&type=script&lang=js"
export * from "./TopPartners.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Development\\konnektor\\scores\\kon-platform-wallboards-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__